import { render } from "./Appointment.vue?vue&type=template&id=4b42899e&scoped=true"
import script from "./Appointment.vue?vue&type=script&lang=js"
export * from "./Appointment.vue?vue&type=script&lang=js"

import "./Appointment.vue?vue&type=style&index=0&id=4b42899e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b42899e"

export default script